<template>
  <div id="page-login">
    <div class="login-form-container">
      <div class="left-box">
        <div class="content">
          <div class="logo">兆配云CRM</div>
        </div>
      </div>
      <div class="right-box">
        <form class="login-form" @submit.prevent="doSubmit">
          <div class="title">登&nbsp;录</div>
          <div class="field username" :class="{ focus : fcsName }">
            <i class="crm-icon-user"></i>
            <input autocomplete="off" placeholder="请输入用户名" v-model="username" @focus="fcsName=true" @blur="fcsName=false" />
          </div>
          <div class="field password" :class="{ focus : fcsPwd }">
            <i class="crm-icon-lock"></i>
            <template v-if="passwordVisible">
              <input autocomplete="off" name="password" v-model="password" placeholder="请输入密码" @focus="fcsPwd=true" @blur="fcsPwd=false" />
              <i class="crm-icon-eye" @click="passwordVisible=false"></i>
            </template>
            <template v-else>
              <input autocomplete="off" type="password" name="password" v-model="password" placeholder="请输入密码" @focus="fcsPwd=true" @blur="fcsPwd=false" />
              <i class="crm-icon-eye-close-fill" @click="passwordVisible=true"></i>
            </template>
          </div>
          <div class="field tips">
            <el-checkbox v-model="remember">记住密码</el-checkbox>
            <div class="link">忘记密码？</div>
          </div>
          <div class="field submit-btn">
            <el-input type="submit" @click="doSubmit">确认</el-input>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { doLogin } from './services'
export default {
  name: 'PageLogin',
  data () {
    return {
      fcsName: false,
      fcsPwd: false,
      passwordVisible: false,
      username: '',
      password: '',
      remember: false
    }
  },
  mounted () {
    try {
      const up = localStorage.getItem('__upr')
      const upInfo = JSON.parse(up)
      this.username = upInfo && upInfo.username
      this.password = upInfo && upInfo.password
      this.remember = true
    } catch {}
  },
  methods: {
    doSubmit () {
      doLogin(this.username, this.password).then(resp => {
        if (this.remember) {
          localStorage.setItem('__upr', JSON.stringify({
            username: this.username,
            password: this.password
          }))
        } else {
          localStorage.removeItem('__upr')
        }
        this.$store.dispatch('login', resp)
      }).catch(() => {
        this.$message.error('用户名密码错误，请重新登录')
      })
    }
  }
}
</script>
